import { getGlobalNotes, createGlobalNote, editGlobalNote, deleteGlobalNote, getClientNotes, viewNote, getNoteById } from './note.action';
export { noteReducer } from './note.reducer';
export { watchNotes } from './note.saga';

export const noteActions = {
    getGlobalNotes,
    getClientNotes,
    getNoteById,
    createGlobalNote,
    editGlobalNote,
    deleteGlobalNote,
    viewNote,
};
